// @ts-nocheck
import { httpClient } from '../../../core/network';

class EventService {
  static fetchEvents(userId) {
    const apiUrl = `/customers/${userId}/events`;
    return httpClient.get(apiUrl);
  }
}

export default EventService;
